package org.moxultimate.topwithmox.components.crud

import org.w3c.files.File

/** Builds the auto-tag string from title, series, and type joined by " | ". */
fun buildAutoTags(title: String, series: String, type: String): String =
    listOf(title, series, type).filter { it.isNotBlank() }.joinToString(" | ")

/** Reads the natural pixel dimensions of [file] and passes "${w}x${h}" to [onResult]. */
fun detectResolutionFromFile(file: File, onResult: (String) -> Unit) {
    val url = kotlinx.browser.window.asDynamic().URL.createObjectURL(file) as String
    val img = kotlinx.browser.document.createElement("img")
    img.asDynamic().onload = {
        val w = img.asDynamic().naturalWidth as Int
        val h = img.asDynamic().naturalHeight as Int
        kotlinx.browser.window.asDynamic().URL.revokeObjectURL(url)
        onResult("${w}x${h}")
    }
    img.setAttribute("src", url)
}

/**
 * Infers wallpaper type from pixel dimensions using aspect ratio (w/h):
 *  ≥ 2.1  → Widescreen  (21:9, 32:9, ultra-wide)
 *  ≥ 1.0  → Desktop     (4:3, 16:10, 16:9 landscape)
 *  ≥ 0.6  → Vertical    (slightly tall portrait, e.g. rotated monitor)
 *  < 0.6  → Phone       (tall portrait: 9:16, 9:20, etc.)
 */
fun detectTypeFromDimensions(w: Int, h: Int): String {
    val ratio = w.toDouble() / h.toDouble()
    return when {
        ratio >= 2.1 -> "Widescreen"
        ratio >= 1.0 -> "Desktop"
        ratio >= 0.6 -> "Vertical"
        else         -> "Phone"
    }
}

/**
 * Reads natural pixel dimensions of [file] and passes both the resolution string ("WxH")
 * and the inferred wallpaper type to [onResult].
 *
 * @param file Image file to analyse.
 * @param onResult Callback receiving (resolution, type).
 */
fun detectResolutionAndTypeFromFile(file: File, onResult: (resolution: String, type: String) -> Unit) {
    val url = kotlinx.browser.window.asDynamic().URL.createObjectURL(file) as String
    val img = kotlinx.browser.document.createElement("img")
    img.asDynamic().onload = {
        val w = img.asDynamic().naturalWidth as Int
        val h = img.asDynamic().naturalHeight as Int
        kotlinx.browser.window.asDynamic().URL.revokeObjectURL(url)
        onResult("${w}x${h}", detectTypeFromDimensions(w, h))
    }
    img.setAttribute("src", url)
}
